import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const SummaryLeftTable = props => (
  <Table className={props.classes.table}>
    <TableBody>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}></TableCell>
        <TableCell className={props.classes.tablecontent_first}></TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("uptime_frame_size") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.framesize}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("uptime_efficiency") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.efficiency.toFixed(3) + "%"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_total_bandwidth") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.totalbandwidth.toFixed(4) + " Gb/s"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_usable_bandwidth") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.usablebandwidth.toFixed(4) + " Gb/s"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("uptime_nw_overhead2") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.networkoverhead.toFixed(4) + " Gb/s"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_line_utilization") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.utilization.toFixed(3) + "%"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_tx2") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.formatNumber(props.subtestUptimeResults.txcount)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_rx2") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.formatNumber(props.subtestUptimeResults.rxcount)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_error_count") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.formatNumber(props.subtestUptimeResults.errorcount)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_link_down") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.linkdowntime}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_error_time") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.subtestUptimeResults.errortime}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_error_ratio") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.formatNumber(props.subtestUptimeResults.errorratio)}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
export default withStyles(styles)(SummaryLeftTable);
